import { render, staticRenderFns } from "./RoutineTasks.vue?vue&type=template&id=6af727fb&scoped=true"
import script from "./RoutineTasks.vue?vue&type=script&lang=js"
export * from "./RoutineTasks.vue?vue&type=script&lang=js"
import style0 from "./RoutineTasks.vue?vue&type=style&index=0&id=6af727fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af727fb",
  null
  
)

export default component.exports